import { fetchFactory } from 'isotope-client'

export const changeLanguage = (language) => fetchFactory('/admin/rtv-users/changeLanguage', { body: JSON.stringify({ language }), method: 'post' }, '/api')